{
  "kk": {
    "citySelectBottomSheet": {
      "emptySearchResultsTitle": "Ешнәрсе табылмады",
      "tryAgain": "Іздеу сұрауыңызды өзгертіп көріңіз немесе тексеріңіз",
      "clearInput": "Енгізілген қаланы өшіру"
    }
  },
  "ru": {
    "citySelectBottomSheet": {
      "emptySearchResultsTitle": "Ничего не найдено",
      "tryAgain": "Попробуйте изменить поисковый запрос и проверить, нет ли опечаток",
      "clearInput": "Очистить поле ввода"
    }
  },
  "en": {
    "citySelectBottomSheet": {
      "emptySearchResultsTitle": "Nothing found",
      "tryAgain": "Try changing the search query and checking for typos",
      "clearInput": "Clear input"
    }
  }
}
